export default "__VITE_ASSET__Br7QaI18__"